module.exports = __webpack_public_path__ + "static/ziggy_report-sc-cf193762540fa7ecd87bef27b955404f.png";